import React from 'react'
import Form from 'react-bootstrap/Form'
import MutedText from 'shared/forms/muted-text'

function RecentPaymentChange({ params, setParams }) {
  const checked = params.recentPaymentChange === true

  return (
    <>
      <Form.Check
        inline
        checked={checked}
        label="Recent Payment Change"
        name="recent-payment-change"
        type={'checkbox'}
        onChange={() =>
          setParams({
            ...params,
            recentPaymentChange: !params.recentPaymentChange
          })
        }
        id={'recent-payment-change-checkbox'}
      />
      <MutedText as="div" className="ms-4">
        Vendor has had a change in payment method in the past 30 days
      </MutedText>
    </>
  )
}

export default RecentPaymentChange
